import { Avatar, AvatarFallback, AvatarImage } from '@/components/ui/avatar';
import { UserRound } from 'lucide-react';

interface SpeakerChipProps {
  name: string;
  headshotUrl?: string;
  title?: string;
  link?: string;
  size?: 'sm' | 'default';
}

const sizeConfig = {
  sm: { avatar: 'size-6', icon: 'size-3' },
  default: { avatar: 'size-12', icon: 'size-5' },
};

export function SpeakerChip({
  name,
  headshotUrl,
  title,
  link,
  size = 'default',
}: SpeakerChipProps) {
  const { avatar, icon } = sizeConfig[size];
  return (
    <div className="flex min-w-0 items-center gap-1.5">
      <Avatar className={`${avatar} shrink-0`}>
        {headshotUrl ? <AvatarImage src={headshotUrl} alt={name} /> : null}
        <AvatarFallback>
          <UserRound className={`${icon} text-muted-foreground`} />
        </AvatarFallback>
      </Avatar>
      <a
        href={link}
        target="_blank"
        rel="noopener noreferrer"
        className="truncate text-data-card-xs text-foreground font-semibold underline underline-offset-2 transition-opacity hover:opacity-70"
      >
        {name}
      </a>
      <small className="truncate text-data-card-xxs text-muted-foreground">{title}</small>
    </div>
  );
}
